import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DownloadableReadUrlType } from 'src/app/models/selected-files-data';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { FavoriteService } from 'src/app/services/favorite/favorite.service';
import { forkJoin } from 'rxjs';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { MobileVerificationFlowService } from 'src/app/services/Auth/mobile-verification-flow.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
@Component({
  selector: 'ipm-download-beat',
  templateUrl: './download-beat.component.html',
  styleUrls: ['./download-beat.component.scss']
})
export class DownloadBeatComponent implements OnInit, OnChanges {
  @Input() producerData: any ;
  isAcceptTermCondition: any = '';
  downloadLeft: number = 0;
  downloadToolTipMessage: string = "";
  downloadTotalQuota: number = 10;
  isShowCompletedProfile: boolean = false;
  isButtonIsDisable: boolean  = false;
  buttonText: string = "Download";
  constructor( private followService: FavoriteService,
    private beatService: BeatsService,
    public commonFuncService : CommonService,
    private mobileVerificationFlow: MobileVerificationFlowService,
    private router: Router,
    public browserStorageService: BrowserStorageService,
    public ga4Tracking: Ga4trackingService,
    public compgainService: CampaignService) {}


  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges ) {
    if(changes['producerData']) {
      this.downloadLeft  = this.producerData.mp3DownloadCount;
      if (this.producerData?.currentUser.mobile &&  this.producerData?.currentUser.mobile?.isVerified) {
        this.downloadTotalQuota = 30; 
      }
      if (this.producerData?.currentUser &&  this.producerData?.currentUser?.role === "customer") {
          if (!this.producerData?.currentUser?.name && 
            !this.producerData?.currentUser?.email &&
            Object.keys(this.producerData?.currentUser.mobile).length === 0)  {
            this.isShowCompletedProfile = true;
          }
      }
      this.buttonText  = this.producerData?.isFollow ? 'Download' : 'Follow & Download'
      this.buttonCondition(true);      
    }
  }

  buttonCondition(isInitialize: boolean) {
    if (this.producerData?.currentUser?.role === 'customer') {
      if (this.producerData?.currentUser.mobile?.isVerified && this.downloadLeft === 0) {
        this.isButtonIsDisable = true;
      } else if (this.producerData?.currentUser.mobile?.isVerified && this.downloadLeft > 0) {
        this.isButtonIsDisable = !this.isAcceptTermCondition ?  true : false;
      } else if (!this.producerData?.currentUser.mobile?.isVerified && this.downloadLeft === 0) {
        this.isButtonIsDisable = false;
        if (isInitialize) {
          this.buttonText  = "Complete your profile";
        }
      } else {
        this.isButtonIsDisable = !this.isAcceptTermCondition ?  true : false;
      }
    } else {
        this.isButtonIsDisable = !this.isAcceptTermCondition || this.downloadLeft === 0 ? true : false;
    }
  }

  close() {
    this.commonFuncService.closePopUp();
  }

  callingApi() {
    if (this.buttonText === "Complete your profile") {
      this.goToProfile();
    } else {
      let followArray: Array<any> = []
      if (!this.producerData?.isFollow) {
        let followApiCall = this.followService.followProducer(this.producerData?.currentBeatData?.producer?._id);
        followArray.push(followApiCall);
      } 

       let sendData = {
          beat_id: this.producerData?.currentBeatData?._id,
          beat_file_type: DownloadableReadUrlType.Preview,
        };
      let getUrlDownloadable = this.beatService.getReadBaseUrl(sendData);
      followArray.push(getUrlDownloadable);
      forkJoin(followArray).subscribe( res => {
        this.close();
        if (res && res.length > 0) {
          let currentType: any = this.browserStorageService?.getCurrentRoles() ? this.browserStorageService?.getCurrentRoles() : "guest"
          let downloadData:any =  res[res.length -1];
          let attributes: any = {
            category: "Beat",
            label: "download",
            action: "downloadMp3",
            userRole: currentType,
            userId : this.browserStorageService?.getUserId() || 'guest',
          }
          this.ga4Tracking.sendEvent("free_mp3_download_event", attributes);
          const currentUrl: string = this.router.url; 
          if (this.producerData?.currentBeatData?.is_ad && !currentUrl.includes('@')) {
            this.compgainService.trackClick(this.producerData?.currentBeatData).subscribe();
            this.compgainService.trackDownloadClick(this.producerData?.currentBeatData).subscribe();
          }
          this.commonFuncService.downloadFile(downloadData?.data?.url, 'audio', this.producerData?.currentBeatData );

        }
      }, error => {
          if (this.mobileVerificationFlow.triggerFromError(error, 'download')) {
            return;
          }
         this.commonFuncService.showToastError(error);
      });
    }
  }

  goToProfile() {
    if ( this.producerData?.currentUser?.role === "customer") {
      this.commonFuncService.closePopUp();
      this.commonFuncService.isShowMusicConfirmationPopup.next('/settings');
    }
  }

  onChangeCheckBox(event: any) {
    this.buttonCondition(false);
  }
}
